import { tokens } from '@cub-com-br/theme/tokens';
import { Box, useMediaQuery } from '@mui/material';
import { useLayoutEffect, useRef, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Footer } from '~/components/footer/footer';
import { Header } from '~/components/header/header';
import { Navbar } from '~/components/navbar/navbar';
import {
  CONTENT_MAX_WIDTH,
  containerSx,
  DESKTOP_BREAKPOINT,
  MAIN_CONTENT_WIDTH,
  MOBILE_BOTTOM_GAP,
  NAVBAR_HEIGHT,
  SIDE_PANEL_GAP,
  SIDE_PANEL_WIDTH,
} from '~/components/shell/layout';
import { TipsPanel } from '~/screens/dicas/tips-panel';

export const Shell = () => {
  const isDesktop = useMediaQuery(DESKTOP_BREAKPOINT);
  const location = useLocation();
  const mainContentRef = useRef<HTMLDivElement>(null);
  const [sidePanelMaxHeight, setSidePanelMaxHeight] = useState<number>();

  useLayoutEffect(() => {
    if (!isDesktop || !mainContentRef.current) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => setSidePanelMaxHeight(entry.contentRect.height));
    observer.observe(mainContentRef.current);

    return () => observer.disconnect();
  }, [isDesktop]);

  if (isDesktop && location.pathname === '/dicas') {
    return <Navigate to="/onboarding" replace />;
  }

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh" sx={{ backgroundColor: tokens.grey50 }}>
      <Header />
      <Box
        flexGrow={1}
        display="flex"
        flexDirection="column"
        pt={isDesktop ? 3 : 0}
        pb={isDesktop ? 3 : `${NAVBAR_HEIGHT + MOBILE_BOTTOM_GAP}px`}
        px={isDesktop ? 3 : '22px'}
      >
        <Box
          display="flex"
          flexGrow={1}
          alignItems="flex-start"
          mx="auto"
          width="100%"
          maxWidth={CONTENT_MAX_WIDTH}
          gap={isDesktop ? SIDE_PANEL_GAP : 0}
        >
          <Box
            ref={mainContentRef}
            flexGrow={1}
            minWidth={0}
            maxWidth={isDesktop ? MAIN_CONTENT_WIDTH : undefined}
            display="flex"
            flexDirection="column"
            sx={containerSx}
          >
            <Box flexGrow={1}>
              <Outlet />
            </Box>
            <Box px={3} pb={isDesktop ? 3 : 2}>
              <Footer />
            </Box>
          </Box>
          {isDesktop && (
            <Box
              flexShrink={0}
              alignSelf="flex-start"
              width={SIDE_PANEL_WIDTH}
              p={2}
              sx={{
                ...containerSx,
                position: 'sticky',
                top: 24,
                maxHeight: sidePanelMaxHeight !== undefined ? `${sidePanelMaxHeight}px` : 'calc(100vh - 48px)',
                overflowY: 'auto',
              }}
            >
              <TipsPanel showScrollIndicator />
            </Box>
          )}
        </Box>
      </Box>
      {!isDesktop && <Navbar />}
    </Box>
  );
};
